import React from "react";
import { MANUAL_LOCALES } from "../manual/i18n/locale";
import { useManualLocale } from "../manual/i18n/LocaleContext";

export default function DocsLanguageSwitch() {
  const { locale, setLocale } = useManualLocale();

  return (
    <div className="flex items-center" role="group" aria-label="Language">
      {MANUAL_LOCALES.map((item) => {
        const active = locale === item.code;
        return (
          <button
            key={item.code}
            type="button"
            aria-current={active ? "true" : undefined}
            onClick={() => setLocale(item.code)}
            className={`px-1.5 py-1 text-xs font-bold tracking-wide ${
              active
                ? "text-sepm-primary dark:text-sepm-primary-dark"
                : "text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
            }`}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
